import { AxiosResponse } from 'axios'
import { api } from '@/lib/api-client.ts'
import { User } from '@/store/user.ts'

export type UserEditData = {
  name?: string
  surname?: string
  email?: string
  activeProjectTabs?: string[]
  activeProjectStage?: string | null
  /** IRI of an OrganizationMember row the user already holds, e.g. "/organization_members/173". */
  activeMembership?: string
}
export const editUser = async (
  userId: number | undefined,
  userEditData: UserEditData,
): Promise<AxiosResponse<User>> => {
  // console.log(`editing user data...`)
  return api.patch(`/users/${userId}`, userEditData)
}
